module.exports = __webpack_public_path__ + "img/banner.d25c0e3a.png";